import { SOLD_SERVICE_STATUS } from '@sales-center/common'

export const soldServiceStatusText = (status: SOLD_SERVICE_STATUS) => {
  switch (status) {
    case SOLD_SERVICE_STATUS.Completed:
      return 'Completed'
    case SOLD_SERVICE_STATUS.NotSent:
      return 'Not Sent'
    case SOLD_SERVICE_STATUS.Processing:
      return 'Processing'
    case SOLD_SERVICE_STATUS.Revise:
      return 'Revise'
    case SOLD_SERVICE_STATUS.Submitted:
      return 'Submitted'
    default:
      return 'Unknown'
  }
}
